export default {
  acordar_horario: 'Horario a programar',
  aerolinea: 'Empresa aérea',
  alojamiento: 'Nombre de alojamiento y/o dirección',
  asientos: 'Asientos',
  atencion: 'Atención !!!',
  atencion_clientes: 'Atención a clientes',
  atencion_texto1: 'Realizar el pago de tu reserva o crear otro trayecto y continua viajando.',
  atencion_texto2: '',

  boton_condiciones: 'Ver políticas',
  btn_continuar: 'Continuar',
  btn_pagar: 'Pagar reserva',
  buscando: 'Buscando',
  buscar: 'Buscar',
  buscar_transfer: 'Buscar transfer',

  cancela_1: 'Cancela tu reserva!!',
  cancela_2: 'Cancelación sin cargo hasta 48hs del viaje',
  cancela_3: '',
  cancelar: 'Cancelar',
  cancelar_reserva: 'Cancelar reserva',
  cantidad_pasajeros: 'Pasajeros',
  cargando: 'Cargando',
  centro_ayuda: 'Centro de ayuda',
  cerrar: 'Cerrar',
  codigo_pais_invalido: 'Código de país no válido',
  completar_los_siguientes_datos: 'Completar los siguientes datos',
  comprobante_pago_pix: 'Comprobante de pago PIX',
  comprobante_requerido: 'Comprobante requerido',
  configuracion_medio_no_encontrada: 'Configuración de {medio} no encontrada. Código ({codigo}).',
  condiciones: 'Ver polítcas de alteraciones y cancelamientos',
  confirma_tus_datos_personales: 'Confirma tus datos personales',
  confirmar: 'Confirmar',
  confirmar_pago_pix: 'Confirmar pago PIX',
  confirmar_reserva: 'Continuar reserva',
  confirmar_reserva_y_pagar: 'Confirmar reserva y seleccionar método de pago...',
  confirmar_reservas: 'Confirmar reservas',
  conozca_stripe: 'Clic... conozca Stripe',
  contacto: 'Contacto',
  consultar_precio: 'Consultar precio',
  control_cant_pasajeros: 'Verifique la cantidad de pasajeros',
  control_completar: 'Completar',
  control_datos_pasajeros: 'Debe completar los datos de los pasajeros',
  control_email: 'Completar email correctamente',
  control_fecha_mayor_igual_hoy: 'La fecha debe ser mayor al día de hoy',
  control_mayores_mayor_cero: 'La cantidad de mayores debe ser mayor a cero',
  control_movil: 'Completar móvil',
  costo_total: 'Costo total',

  datos_de_la_reserva: 'Datos de la reserva',
  datos_de_los_pasajeros: 'Datos de los pasajeros',
  datos_del_viaje: 'Datos del viaje',
  de: 'De',
  debe_aceptar_politica_cancelamiento: 'Debe aceptar Políticas de Cancelamiento',
  debe_aceptar_terminos: 'Debe aceptar Términos y Condiciones',
  detalle_reserva: 'Detalles de la reserva',
  dia: 'Día',
  distancia_total: 'Distancia total',

  email: 'Email',
  email_enviado: 'Email enviado',
  elimina_trayectos_cargados: '¿Elimina trayectos cargados?',
  eliminar: 'Eliminar',
  eliminar_trayecto_1: '¿Elimina trayecto?',
  enviando_email: 'Enviando email',
  estados_reserva: {
    estado_0: 'Con error',
    estado_1: 'Emitida',
    estado_2: 'Pendiente de pago',
    estado_40: '',
    estado_45: '',
    estado_50: 'Pendiente confirmación pago en destino (pago a bordo)',
    estado_55: 'Pago en destino confirmado (paga a bordo)',
    estado_60: '',
    estado_70: 'Pago con QR code PIX pendiente de confirmación',
    estado_98: 'Pagada (sin procesar)',
    estado_99: 'Procesada'
  },
  err_enviando_email: 'Problemas al enviar el email',
  err_network_connection: 'Verificar conexión con servidor. Intente mas tarde o consulte soporte técnico.',
  error_alta_reserva: 'No pudimos confirmar la reserva. Si el problema continúa, contacte soporte e indique el código que aparece.',
  error_carga_puntos: 'Error al cargar los puntos',
  espero_contacten: 'Espero que me contacten',

  falta_poco: '¡Falta poco! Complete sus datos para continuar con el pago',
  falta_poco_pantalla3: 'Verifique que los datos de su reserva son correctos y confirme el pago',
  fecha_transfer: 'Fecha transfer',
  formato_comprobante_pix: 'Formatos permitidos: PDF, JPG, JPEG, PNG. Tamaño máximo: 10MB',

  hora: 'Hora',
  hora_llegada: 'Hora llegada',
  horario_del_vuelo: 'Horario del vuelo',
  hotel_posada_en: 'Hotel/posada en ',
  hs: 'hs',

  intercambiar_origen_destino: 'Intercambiar origen y destino',

  llegando_a: 'Llegando a',
  limpiar: 'Limpiar',
  limpiar_busqueda: 'Limpiar búsqueda',

  maletas_1: 'Maletas por persona',
  maletas_2: 'Una maleta mediana',
  maletas_3: 'Una maleta chica',
  medios_de_pago: 'Medios de pago',
  medios_de_pago_seleccione: 'Seleccione el medio de pago',
  medios_pagos_no_configurados: 'Medios de pago no configurados',
  metodo_de_pago: 'Método de pago',
  modificar_reserva: 'Modificar reserva',
  modifica_1: 'Modificar tu reserva',
  modifica_2: 'Modifica tu reserva sin cargo en cualquier momento',
  modifica_3: '',
  monto_a_pagar: 'Monto a pagar',
  movil: 'Móvil',
  movil_whatsapp: 'Whatsapp - móvil',

  nombres_completos: 'Nombres completos',
  nombre_de_pasajeros: 'Nombres completos de los pasajeros',
  no_elimino_trayecto: 'No eliminó trayecto',
  no_encontro_resultado: 'No encontro resultados',
  no_gracias: 'No gracias',
  no_hay_coordenadas_disponibles: 'No hay coordenadas disponibles para este punto',
  no_hay_resultados: 'No hay resultados',
  nro_vuelo: 'Número de vuelo',

  ordinal_trayecto: {
    ordinal_1: 'Primer',
    ordinal_2: 'Segundo',
    ordinal_3: 'Tercer',
    ordinal_4: 'Cuarto',
    ordinal_5: 'Quinto',
    ordinal_6: 'Sexto',
    ordinal_7: 'Septimo'
  },
  otros_datos: 'Otros datos',

  pagar: 'Pagar',
  pagar_reserva: 'Pagar reserva',
  para: 'Para',
  pasajeros: 'Nombre de Pasajeros',
  pago_a_bordo: 'Pago en destino (dinero, a bordo)',
  pago_a_bordo_completar_datos: 'Debe completar: contacto, email y móvil',
  pago_a_bordo_confirmado: 'Excelente, hemos confirmado su pago en destino (pago a bordo)',
  pago_a_bordo_representante: 'Uno de nuestros representante se pondrá en contacto con usted para confirmar la reserva',
  pago_a_bordo_txt: 'Abonar en dinero a tu llegada',
  pago_con_paypal: 'Pago con Paypal',
  pago_con_paypal_txt: 'Abonar con cuenta de Paypal',
  pago_con_pix: 'Pago con QR code PIX',
  pago_con_pix_pendiente_de_confirmacion: 'Pago con QR code PIX pendiente de confirmación',
  pago_pix_instrucciones: 'Lea el código QR con su aplicación, pague y confirme el pago cargando el comprobante',
  pago_con_pix_txt: 'Abonar con QR code PIX',
  pago_con_tarjeta: 'Pago con tarjeta de crédito o débito',
  pago_con_tarjeta_txt: 'Abona con tarjeta de crédito o débito',
  pago_por_stripe: 'Confirmar el pago de tu reserva con tarjeta de crédito o débito',
  plataforma_de_pago: 'Plataforma de pago',
  politica_privacidad: 'Política de privacidad',
  preparando_pago_paguelofacil: 'Aguarde, preparando pago en Páguelo Fácil ...',
  preparando_pago_paypal: 'Aguarde, preparando pago en Paypal ...',
  preparando_pago_pix: 'Aguarde, preparando pago con QR code PIX ...',
  preparando_pago_stripe: 'Aguarde, preparando pago en Stripe ...',
  precio: 'Precio',
  precio_por_pasajero: 'Precio por pasajero',
  pre_reserva: 'Abrir Pre Reserva',

  reserva: 'Reserva',
  reserva_confirmada: 'Su reserva ha sido confirmada, en breve recibirá los datos del viaje',
  reserva_id: 'Reserva id',
  reserva_link_pago: 'Reserva pendiente de envío y confirmación de pago por medio de link de pago',
  reserva_no_confirmada: 'Su reserva no ha sido confirmada',
  reserva_ya_no_disponible: 'Esta reserva ya no está disponible',
  reserva_pago_a_bordo: 'Reserva pago a bordo. Nuestro personal se pondrá en contacto con ustedes para confirmar la misma',
  reserva_pago_a_bordo_confirmada: 'Reserva con pago a bordo confirmada',
  reserva_pendiente: 'Reserva pendiente de pago',
  reservar: 'Reservar',
  ruta: 'Trajecto',
  ruta_entre_puntos: 'Ruta entre puntos',

  saliendo_de: 'Saliendo de',
  seleccionar_comprobante_pix: 'Seleccionar comprobante de pago PIX',
  seleccionar_horario: 'Seleccionar horario',
  seleccionar_otro_trayecto: 'Crear otro trayecto',
  seleccione_ambos_puntos: 'Seleccione ambos puntos para ver la ruta',
  servicios: 'Servicios',
  servicios_otra_informacion: 'Mas información para tu viaje',
  sesion_expiro: 'La sesión expiro',
  stripe_no_devolvio_url: 'Verifique su pago porque Stripe no devolvió URL de muestra de la reserva',
  sub_total: 'Subtotal',

  te_enviamos_voucher: 'Enviamos tu voucher de reserva aquí',
  telefono_contacto: 'Teléfono de contacto',
  telefono_contacto_msq: 'Número de teléfono para contactarte por cualquier eventualidad',
  telefono_lead_msg: 'Lo necesitamos para contactarte por cualquier eventualidad',
  telefono_placeholder: 'Ingrese su número sin el código de país',
  telefono_placeholder_msg: 'Número de teléfono para contactar al pasajero principal',
  tiene_whatsapp: 'Disponible en WhatsApp',
  sin_whatsapp: 'No disponible en WhatsApp',
  tiene_telegram: 'Disponible en Telegram',
  sin_telegram: 'No disponible en Telegram',
  click_para_cambiar: 'Click para cambiar estado',
  terminos: 'Declaro que he leído la Política de privacidad y que acepto los Términos y condiciones de reserva y los Términos y condiciones de transporte',
  terminos_y_condiciones: 'Términos y condiciones',
  tiempo_estimado: 'Tiempo estimado de viaje',
  tipo_servicio: 'Tipo de servicio',
  tipo_transfer: {
    auto03: 'Transfer privado auto 1 a 3 personas',
    auto08: 'Transfer privado auto 4 a 8 personas',
    auto12: 'Transfer privado auto 9 a 12 personas',
    auto16: 'Transfer privado auto 13 a 16 personas',
    auto20: 'Transfer privado auto 17 a 20 personas',
    auto25: 'Transfer privado auto 21 a 25 personas',
    auto30: 'Transfer privado auto 26 a 30 personas',
    bp: 'Transfer privado bus',
    bu: 'Transfer regular bus',
    hasta10: 'Privado hasta 10 pasajeros',
    hasta13: 'Privado hasta 13 pasajeros',
    hasta17: 'Privado hasta 17 pasajeros',
    hasta22: 'Privado hasta 22 pasajeros',
    hasta4: 'Privado hasta 4 pasajeros',
    hasta5: 'Privado hasta 5 pasajeros',
    hasta5_suburban: 'Suburban hasta 5 pasajeros',
    hasta6: 'Privado hasta 6 pasajeros',
    hasta8: 'Privado hasta 8 pasajeros',
    mb: 'Transfer regular mini bus',
    mp: 'Transfer privado mini bus',
    t3: 'Transfer privado de 1 a 3 personas',
    t5: 'Transfer privado hasta 5 personas',
    t6: 'Transfer privado hasta 6 personas',
    va: 'Transfer regular van',
    vp: 'Transfer privado van hasta 13 personas'
  },
  total: 'Total',
  transfer: 'Transfer',
  transfer_privado: 'Transfer privado',
  transfer_regular: 'Transfer regular',
  transfer_horario: 'Horario de transfer',
  trayecto: 'Trayecto',
  trayectos: 'Trayectos',
  trayectos_intercambiados: 'Trayectos intercambiados',

  ver_punto_en_mapa: 'Ver punto en el mapa',
  ver_ruta_en_mapa: 'Ver ruta en el mapa',
  verificar_parametros: 'verifique los parámetros',
  version: 'v.',
  powered_by: 'Powered by',
  volver_atras: 'Volver atrás'
}
